module.exports = __webpack_public_path__ + "media/bootstrap-icons/google-7d820a24.svg";